import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { fetchNewsletters, selectNewsletters } from '@client/myAccount/newsletters/redux/redux';
import { NewslettersType } from 'b2b-common/core/account/api/Newsletters.types';

export const useNewslettersEffect = (): RemoteRecord<NewslettersType> => {
  const dispatch = useDispatch();
  const newsletters = useSelector(selectNewsletters);

  useEffect(
    (): void => {
      dispatch(fetchNewsletters());
    },
    [],
  );

  return newsletters;
};
